import styled from 'styled-components';

export const Root = styled.div`
  text-align: center;
`;

export const Action = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding: 0 4px;
`;
